export default __webpack_public_path__ + "static/media/it930-a033-5.c84dd2a3.jpg";